import * as React from "react";
import KnowladgeHowInterprateResult from "../containers/KnowladgeHowInterprateResult";

export default (props) => <KnowladgeHowInterprateResult {...props} />;
